// An audio can have several styles (aesthetic + soft). The API sends `styles` (a list);
// `style` is just the first one.
export const AUDIO_STYLES = ["aesthetic", "soft", "film", "velo"];

export const stylesOf = (audio) => (audio?.styles?.length ? audio.styles : audio?.style ? [audio.style] : []);

/** "AESTHETIC + SOFT" */
export const styleText = (audio, sep = " + ") => stylesOf(audio).map((s) => s.toUpperCase()).join(sep);
